// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");

function cppEscape(prim) {
  return $dot$dot.cppEscape(prim);
}

exports.cppEscape = cppEscape;
/* .. Not a pure module */
